import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="py-24 relative overflow-hidden" data-id="element-229">
      <div className="absolute inset-0 bg-gradient-to-b from-cyan-900/20 to-dark pointer-events-none" data-id="element-230"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 text-center" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-232">
          <div className="inline-block mb-4" data-id="element-233">
            <span className="text-5xl" data-id="element-234">🏆</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-display font-bold text-white mb-4" data-id="element-235">
            MEGA PACK <br className="md:hidden" data-id="element-236" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500" data-id="element-237">
              INTELIGENCIA ARTIFICIAL
            </span>
          </h2>

          <div className="inline-block bg-white/10 border border-white/20 rounded-full px-6 py-2 mb-8" data-id="element-238">
            <p className="text-xl font-bold text-white" data-id="element-239">
              3 Tomos + 3 Bonos + Workflow Total
            </p>
          </div>

          <div className="space-y-4" data-id="element-240">
            <p className="text-2xl font-medium text-gray-300" data-id="element-241">
              La trinidad completa:{' '}
              <span className="text-green-400" data-id="element-242">ChatGPT</span> ·{' '}
              <span className="text-purple-400" data-id="element-243">DeepSeek</span> ·{' '}
              <span className="text-orange-400" data-id="element-244">Claude</span>
            </p>
            <p className="text-xl text-cyan-400 font-bold" data-id="element-245">
              240+ páginas. Todo resuelto. 100% en versiones gratuitas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}